
export interface UserPreferences {
  notifications: {
    email: boolean;
    sms: boolean;
    push: boolean;
    tradeExecution: boolean;
  };
  security: {
    twoFactorEnabled: boolean;
    ipWhitelisting: boolean;
  };
  display: {
    currency: string;
    timezone: string;
    language: string;
  };
}

export const settingsService = {
  getPreferences: (): UserPreferences => ({
    notifications: {
      email: true,
      sms: false,
      push: true,
      tradeExecution: true
    },
    security: {
      twoFactorEnabled: true,
      ipWhitelisting: false
    },
    display: {
      currency: 'USD',
      timezone: 'UTC+0 (London)',
      language: 'English (US)'
    }
  })
};
